
<app-header class="darkBannerImage" bannerImage="contactUs.webp"></app-header>


<div class="row mb-3">
  <div class="col">
      <!-- <h6>Find information about YaraVita™ products in your country</h6> -->
      <h6 i18n="@@contactP1">Please select one of the countries below for more information about YaraVita™ products</h6>
  </div>
<div>

<div class="row mb-3 mt-2">
  <div class="col">
      <ul>
          <li *ngFor="let contact of contacts">
              <a href="{{contact.contactpage}}" target="_blank">{{contact.countryname}}</a>
          </li>
      </ul>
  </div>
</div>

<!-- 
<h5>Registered Office</h5>
<p>Manor Place, Wellington Road, The Industrial Estate, Pocklington, YO42 1DN, UK</p>
<p>Registered in England No. 03818176</p> -->

<h5 i18n="@@RegisteredOffice">Registered Office</h5>
<p>Yara UK Limited, Pocklington Industrial Estate, Pocklington, York, YO42 1DN</p>
<p>Registered in England No. 03818176</p>

